// extracted by mini-css-extract-plugin
export default {"beta-label":"BetaLabel_beta-label__lsfWe"};